export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/video_marketing.c295058.svg";